import { Controller, useForm } from "react-hook-form";
import classNames from "classnames";

import { CCard, CCardBody, CCol, CCollapse, CRow } from "@coreui/react";

import { usePermissionCheck } from "src/1/common/components/others";
import { Magnifying } from "src/common/assets/icons";
import { CButton, CInput, CSelect } from "src/common/components/controls";
import { CActionGroup } from "src/common/components/others";
import { ENTITY_GROUP_CODE, PERMISSION_VALUE } from "src/configs/constant";
import { Can } from "src/utils/ability";
import { useMobileDevice } from "src/utils/hooks/viewport";

export const ComboSuggestToolbar = ({
  params,
  onApprove,
  onSearch,
  onAdd,
  onEdit,
  onRemove,
  canEdit,
  canRemove,
  canApprove,
}) => {
  //#region Data
  const { control, handleSubmit } = useForm({
    defaultValues: params,
  });

  const isMobile = useMobileDevice();

  const checkPermission = usePermissionCheck();
  //#endregion

  //#region Event
  const onClick = (state) => {
    switch (state) {
      case "add":
        return onAdd();
      case "edit":
        return onEdit();
      case "remove":
        return onRemove();
      case "print":
        return;
    }
  };

  const search = handleSubmit((searchValues) => onSearch(searchValues));
  //#endregion

  //#region Render
  return (
    <CCard className={classNames("toolbar", !isMobile && "sticky")}>
      <CCardBody>
        <CRow>
          <CCol xs="12" className="action">
            <div>
              <CActionGroup
                onClick={onClick}
                canAdd={checkPermission({
                  [ENTITY_GROUP_CODE.DE_XUAT_COMBO]: PERMISSION_VALUE.CREATE,
                })}
                canEdit={
                  canEdit &&
                  checkPermission({
                    [ENTITY_GROUP_CODE.DE_XUAT_COMBO]: PERMISSION_VALUE.UPDATE,
                  })
                }
                canRemove={
                  canRemove &&
                  checkPermission({
                    [ENTITY_GROUP_CODE.DE_XUAT_COMBO]: PERMISSION_VALUE.DELETE,
                  })
                }
              />
            </div>
            <Can
              do={PERMISSION_VALUE.APPROVE}
              on={ENTITY_GROUP_CODE.DE_XUAT_COMBO}
            >
              <CButton
                disabled={!canApprove}
                onClick={onApprove}
                className="mr-2"
              >
                Xác nhận
              </CButton>
            </Can>
          </CCol>
        </CRow>

        <CCollapse show>
          <CRow className="mt-3">
            <CCol xs="2">
              <Controller
                control={control}
                name="status"
                render={({ field }) => (
                  <CSelect {...field} label="Trạng thái" options={[]} />
                )}
              />
            </CCol>
            <CCol xs="2">
              <Controller
                control={control}
                name="code"
                render={({ field }) => (
                  <CInput
                    {...field}
                    label="Mã combo"
                    placeholder="Tìm kiếm theo mã combo"
                  />
                )}
              />
            </CCol>
            <CCol xs="3">
              <Controller
                control={control}
                name="name"
                render={({ field }) => (
                  <CInput
                    {...field}
                    label="Tên combo"
                    placeholder="Tìm kiếm theo tên combo"
                  />
                )}
              />
            </CCol>
            <CCol xs="5" className="btn-search flex items-end justify-end">
              <div className="form-group c-input w-fit">
                <CButton
                  icon={<Magnifying />}
                  onClick={search}
                  className="mr-0"
                >
                  Tìm kiếm
                </CButton>
              </div>
            </CCol>
          </CRow>
        </CCollapse>
      </CCardBody>
    </CCard>
  );
  //#endregion
};
